<template>
 <v-container v-if="computedLocation !== null" class="drop--overview--context__container pa-0">
    <v-row class="pa-0 drop--overview--context__layout">
      <v-col class="drop--overview--context__component pa-2" cols="12" >
        <DropsContextLocation :selectedDrop="computedLocation" />
      </v-col>
      <v-col  class="drop--overview--context__component drop--overview-context__row pa-2" cols="12" >
        <v-row
        no-gutters
        >
          <v-col cols="6">
            <DropsContextDetail :selectedDrop="computedDetail.drop" />
          </v-col>
          <v-col cols="6">
            <DropsContextShipment :selectedDrop="getDropDetails" />
          </v-col>
        </v-row>
      </v-col>
      <v-col  class="drop--overview--context__component pa-2" cols="12" >
         <ContextExpandList :isClickable="true" :handleClickListItem="selectItem" :title="computeItemsTranslation" :isSynced="true" :syncedObject="selectedUnit" :list="computeExpandList" :closeOnSelect="false" />
      </v-col>
      <v-col v-if="selectedUnit"  class="drop--overview--context__component pa-2" cols="12">
        <DropContextSelectedUnit :selectedUnit="selectedUnit" />
      </v-col>
      <v-col  class="drop--overview--context__component pa-2" cols="12">
         <ContextExpandList :isHoverableActions="true" :toggleAction="handleToggleDropOrder" :title="computeOrdersTranslation" :closeOnSelect="false" :list="computeOrderList" />
      </v-col>
      <v-col v-if="getToggledUnits.length > 0"  class="drop--overview--context__component pa-2" cols="12">
        <DropContextToggledUnits :unitsArray="getToggledUnits" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DropsContextLocation from '@/components/drops/location/DropsContextLocation.vue'
import DropsContextDetail from '@/components/drops/detail/DropsContextDetail.vue'
import DropsContextShipment from '@/components/drops/detail/DropsContextShipment.vue'
import DropContextSelectedUnit from '@/components/drops/detail/DropContextSelectedUnit.vue'
import DropContextToggledUnits from '@/components/drops/detail/DropContextToggledUnits.vue'
import ContextExpandList from '@/components/wrld/generic/ContextExpandList.vue'
export default {
  name: 'DropDetailContext',
  components: {
    DropsContextLocation,
    DropsContextDetail,
    DropsContextShipment,
    DropContextToggledUnits,
    DropContextSelectedUnit,
    ContextExpandList
  },
  props: {},
  data () {
    return {
      toggledOrderRef: []
    }
  },
  methods: {
    ...mapActions({
      selectUnit: 'selectUnit',
      dropSelectedOrder: 'dropSelectedOrder',
      toggleUnit: 'toggleUnit',
      toggleDropOrder: 'toggleDropOrder'
    }),
    selectItem (unitID) {
      this.selectUnit({ unit: this.getDropAllUnits[unitID] })
    },
    handleToggleDropOrder (orderRef, flag) {
      let allUnits = this.getDropAllUnits
      let unitsArray = []
      Object.keys(allUnits).forEach((key) => {
        if (allUnits[key].items !== null) {
          if (allUnits[key].items.length > 0 && allUnits[key].transport.ref === orderRef) {
            unitsArray.push(key)
          }
        }
      })
      if (flag === 'add') {
        const toggledUnits = this.getToggledUnits.map(({ id }) => id)
        unitsArray = unitsArray.filter((key) => {
          return toggledUnits.indexOf(key) < 0
        })
      }
      this.toggleDropOrder({ orderRef: orderRef })
      unitsArray.forEach((key) => {
        this.toggleUnit({ unitID: key })
      })
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getToggledUnits',
      'getSelectedUnit',
      'getDropDetails',
      'getSelectedDrop',
      'getDropTree',
      'getDropAllUnits',
      'getDropOrders',
      'getFilteredDropUnitsHash'
    ]),
    computedLocation: function () {
      if (this.getDropDetails !== null) {
        const { id, departure, arrival, destination, origin, pickupLocal, deliveryLocal } = this.getDropDetails
        const locationObject = {
          id,
          departure: departure != null ? departure : pickupLocal.from,
          arrival: arrival != null ? arrival : deliveryLocal.from,
          destination: {
            id: destination.id,
            companyName: destination.orgName !== undefined ? destination.orgName : destination.organization.name,
            address: destination.address,
            organizationRef: destination.organization != null ? destination.organization.ref : null,
            locationRef: destination.ref,
            openingHours: destination.openingHours,
            accessibility: destination.accessibility,
            equipment: destination.equipment,
            coordinates: destination.coordinates
          },
          origin: {
            id: origin.id,
            companyName: origin.orgName !== undefined ? origin.orgName : origin.organization.name,
            address: origin.address,
            organizationRef: origin.organization != null ? origin.organization.ref : null,
            locationRef: origin.ref,
            openingHours: origin.openingHours,
            accessibility: origin.accessibility,
            equipment: origin.equipment,
            coordinates: origin.coordinates
          }
        }
        return locationObject
      }
      return null
    },
    computedDetail: function () {
      return { drop: this.getDropDetails, units: this.getDropTree(this.$route.params.dropID, false) }
    },
    selectedUnit () {
      return this.getSelectedUnit
    },
    computeExpandList () {
      if (this.getFilteredDropUnitsHash(this.$route.query.dropID) !== null) {
        let labelsArray = []
        const allUnits = this.getFilteredDropUnitsHash(this.$route.query.dropID)
        Object.keys(allUnits).forEach((key) => {
          if (allUnits[key].items !== null) {
            allUnits[key].items.forEach((item) => {
              labelsArray.push({ name: item.ref, subtitle: item.name, id: key })
            })
          }
        })
        return labelsArray
      }
      return []
    },
    computeOrderList () {
      return this.getDropOrders
    },
    computeItemsTranslation (){
      if (this.computeExpandList.length === 1) {
        return this.$i18n.t('drops.items_one')
      } else if (this.computeExpandList.length >= 2 && this.computeExpandList.length  <= 4) {
        return this.$i18n.t('drops.items')
      } else if (this.computeExpandList.length >= 5) {
        return this.$i18n.t('drops.items_two')
      }
    },
    computeOrdersTranslation (){
      if (this.computeOrderList.length === 1) {
        return this.$i18n.t('menu.orders_one')
      } else if (this.computeOrderList.length >= 2 && this.computeOrderList.length  <= 4) {
        return this.$i18n.t('menu.orders')
      } else if (this.computeOrderList.length >= 5) {
        return this.$i18n.t('menu.orders_two')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
